<div class="dashboard-material-theme" fxLayout="column" fxLayoutAlign="center center">
  <dashboard-dialog-title fxFlexAlign="end" [title]="imageSrc ? '' : 'Sensory Data Graph'"></dashboard-dialog-title>
  <div *ngIf="imageSrc" mat-dialog-content>
    <img [src]="imageSrc" alt="metricsImage" />
  </div>
  <div *ngIf="graphData">
    <canvas
      baseChart
      height="400"
      width="800"
      [datasets]="graphDataset"
      [labels]="graphLabels"
      [chartType]="graphType"
      [options]="graphOptions"
      [colors]="graphColors"
    ></canvas>
  </div>
</div>
